var team_filters = ( function( $ ) {

	var $team_filters = false;
	var $to_top_button   = false;

	var _init = function() {
		$team_filters = $( '#team-filters' );
		$to_top_button = $( '#scroll-to-top' );

		$team_filters.find( '#parent-panel' ).on( 'click', _toggle_class );

		$( 'div.option a' ).on( 'click', _scroll );
		$to_top_button.on( 'click', _scroll );
	};

	var _scroll = function( e ) {
		e.preventDefault();
		var element_id = $( this ).attr( 'href' );

		$('html, body').animate( { scrollTop: $( element_id ).offset().top }, 1000 );
	};

	var _toggle_class = function() {
		$team_filters.toggleClass( 'open' );
	};

	$( document ).ready( _init );

} ) ( jQuery );

module.exports = team_filters;